import React, {useState} from 'react';
import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import {Col, Row} from "react-bootstrap";
import LeftEvents from "./LeftEvents";
import styles from "react-responsive-carousel/lib/styles/carousel.min.css";
import {Carousel} from "react-responsive-carousel";
import {Link} from "react-router-dom";

export default function Workshops() {
    const Data = [
        {
            venue: 'IIT Tirupati',
            title: 'Advanced Metrology',
            description: 'Workshop on "Advanced Metrology"\n' +
                '\n' +
                'We are glad to invite you to the workshop on "Advanced Metrology" organized by Department of Mechanical Engineering Indian Institute of Technology Tirupati, Tirupati, Andhra Pradesh – 517619 India.\n' +
                'Objectives\n' +
                '\n' +
                'This workshop is for presenting and discussing fundamentals, novel ideas, innovation trends, and experiences in the field of measurement. To provide the required accuracy at minimum cost with a reduction in the cost of rejects and rework, metrology would have a further objective in a modern engineering plant with different shops like Tool Room, Machine Shop, Press Shop, Plastic Shop, Pressure Die Casting Shop, Electroplating and Painting Shop, Assembly Shop, and also Research, Development and Engineering Department. This workshop gives an insight into reverse engineering concepts as well.\n' +
                'Important topics for discussion\n' +
                '\n' +
                'Overview of Metrology; Dimensional Metrology; GD&T, Form Measurement; Surface Metrology; Interconnection between Manufacturing and Metrology; Reverse Engineering; Practical sessions on each topic\n' +
                '\n' +
                'Workshop date: 5 - 9 December, 2022.\n' +
                '\n' +
                'Hosted By: Department of Mechanical Engineering, IIT Tirupati\n' +
                '\n' +
                'Registration Link : Click here to apply\n' +
                '\n' +
                'The last date of registration has been extended till 30th Nov. 2022. Accordingly, the revised timelines are as follows\n' +
                '\n' +
                'Intimation of Selection (email): 1st Dec. 2022\n' +
                '\n' +
                'Registration fee payment receipt submission: 2nd Dec. 2022\n' +
                '\n' +
                'Participation Confirmation: 2nd Dec. 2022\n' +
                '\n' +
                'Workshop Brochure: Click here to download\n' +
                '\n' +
                '**Note: Please note that the number of participants is limited to a max. of 50 on a first-come-first serve basis.\n' +
                '\n' +
                'Workshop on Advanced Metrology: Tentative Program Schedule',
            img: ['https://files.iittp.ac.in/pdfs/workshop/2022/Advanced%20Metrology_Schedule_17-11-22.png'],
            dt: '5 - 9',
            my: 'Dec 2022',
            category: '2022'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Emerging Learning Methods and Systems',
            description: '1st Workshop on "Emerging Learning Methods and Systems" (ELMS) jointly organized by IIT Tirupati and University of Agder (UiA), Norway.\n' +
                '\n' +
                'We are glad to invite you to the 1st workshop on "Emerging Learning Methods and Systems" (ELMS) jointly organized by IIT Tirupati and University of Agder (UiA), Norway, from 15-17 July 2022 at the permanent campus of our IIT Tirupati.\n' +
                '\n' +
                'This Workshop on ELMS is conducted as a part of the "Indo-Norwegian Collaboration in Intelligent Offshore Mechatronics Systems (INMOST)" project by the faculty from Department of Electrical Engineering, IIT Tirupati and faculty of Engineering and Science, UiA.\n' +
                'This workshop presents the basics of various learning methods, particularly, (i) Supervised Machine Learning (ML), (ii) Deep Learning (DL), (iii) Reinforcement Learning (RL), and (iv) Social and Distributed Learning. It also presents an overview of the application of these methods to solving various system-level problems in various domains like computer vision, automotive, and industrial applications.\n' +
                '\n' +
                'There are many exciting talks lined up for this workshop by eminent researchers from India & abroad. More details about the speakers and the programme can be found at: https://sites.google.com/iittp.ac.in/elms/',
            img: ['https://files.iittp.ac.in/pics/workshop/ELMS/elms1.JPG',
                'https://files.iittp.ac.in/pics/workshop/ELMS/elms2.JPG',
                'https://files.iittp.ac.in/pics/workshop/ELMS/elms3.JPG',
                'https://files.iittp.ac.in/pics/workshop/ELMS/elms4.JPG'],
            dt: '15 - 17',
            my: 'Jul 2022',
            category: '2022'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Active Learning in Online Education',
            description: 'Faculty Development Workshop on “Active Learning in Online Education”\n' +
                '\n' +
                'Centre for Continuing Education (CCE), IITT organized a Faculty Development Workshop on “Active Learning in Online Education” on 3rd October, 2020. The workshop was conducted by Dr. Rucha Joshi, Faculty at Department of Biomedical Engineering, University of California, Davis, USA. ',
            img: ['https://files.iittp.ac.in/pics/aloe/Photo1.jpg',
        'https://files.iittp.ac.in/pics/aloe/Photo2.jpg'
        ],
            dt: '3',
            my: 'Oct 2020',
            category: '2020'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Academic Writing',
            description: 'Three-Day Academic Writing Workshop\n' +
                '\n' +
                'Indian Institute of Technology Tirupati in collaboration with ICSSR-SRC, Hyderabad organised a three-Day workshop on ‘Academic Writing\' during February 07-09, 2020 at IIT Tirupati Campus. This workshop was designed to develop the autonomy, adoptability and responsibility in academic research and writing necessary for young researchers to excel in higher education. It aimed to enhance participants’ ability to engage in academic writing. ',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/AW/18.jpg"
            ],
            dt: '7 - 9',
            my: 'Feb 2020',
            category: '2020'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Spectroscopy & Imaging in a Day',
            description: 'Seminar on "Spectroscopy & Imaging in a Day"\n' +
                '\n' +
                'A one-day seminar on spectroscopy and imaging technologies was hosted by IIT Tirupati on February 1, 2020 (Saturday) and has been jointly organized by the Department of Chemistry and PerkinElmer India Pvt. ltd. The main aim was to discuss the advances in spectroscopy and imaging technologies and their applications to diverse field of chemical sciences, physics, biological sciences, pharmaceuticals and engineering. There were over 75 attendees from the research community that included professors, technicians, postdoctoral fellows, PhD scholars, MSc and MTech students from over 15 different institutes/colleges.... For more details : Click here',
            img: [
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/spectro/8.jpg"],
            dt: '1',
            my: 'Feb 2020',
            category: '2020'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Indian Conceptions of Multiculturalism',
            description: 'Workshop on ‘Indian Conceptions of Multiculturalism’\n' +
                '\n' +
                'Department of Humanities and Social Sciences organised a Workshop on ‘Indian Conceptions of Multiculturalism’ on 8th-9th January 2020, IIT Tirupati ',
            img: [

                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2020/multicul/17.jpg"
            ],
            dt: '8 - 9',
            my: 'Jan 2020',
            category: '2020'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Training School',
            description: 'Advanced Training School on Numerical PDEs & Inverse Problems organized by Department of Mathematics & Statistics ',
            img: [

                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/atsnpd/CoverPhoto.jpg"
            ],
            dt: '9 - 20',
            my: 'Dec 2019',
            category: '2019'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Summer School',
            description: 'Summer School on Artificial Intelligence and Machine Learning organized by Department of Computer Science & Engineering ',
            img: [

                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1728.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1765.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1768.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1771.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1780.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1785.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1786.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1790.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1803.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1835.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1840.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1875.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1886.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1891.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1894.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1899.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1905.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1910.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1912.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1937.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1943.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1946.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1952.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1961.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1969.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1978.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_1998.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2060.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2076.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2078.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2093.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2095.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2117.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2019/aiml/DSC_2026.jpg"
            ],
            dt: '22 - 26',
            my: 'Jul 2019',
            category: '2019'
        },
        {
            venue: 'Sri City, Andhra Pradesh ',
            title: 'Advances in Welding Technology',
            description: 'Workshop on Advances in Welding Technology at Sri City, Andhra Pradesh Organised by IIT Tirupati in association with The Indian Institute of Welding Chennai Branch & IIT Madras ',
            img: [

                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/14.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/18.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/WeldingWorkshop/5.jpg"
            ],
            dt: '22',
            my: 'Nov 2018',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Academic Writing and Publishing',
            description: 'Workshop on Academic Writing and Publishing ',
            img: ["https://files.iittp.ac.in/images/demo/iit/Events/2018/AWWorkshop/I.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/AWWorkshop/II.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/AWWorkshop/III.JPG",
                "https://files.iittp.ac.in/images/demo/iit/Events/2018/AWWorkshop/V.JPG"],
            dt: '17',
            my: 'Nov 2018',
            category: '2018'
        },
        {
            venue: 'IIT Tirupati',
            title: 'Advanced Training School on Functional Analysis',
            description: 'The Department of Mathematics at IIT Tirupati organized a workshop "Advanced Training School on Functional Analysis for Teachers and Research Scholars" during Dec 11 – 23, 2017 at IIT Tirupati',
            img: ["https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/11.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/16.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/17.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/18.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/8.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/9.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/10.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/12.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/13.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/15.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/ATSWorkshop/14.jpg"],
            dt: '11 - 23',
            my: 'Dec 2017',
            category: '2017'
        },
        {
            venue: 'IIT Tirupati',
            title: 'NPTEL',
            description: 'NPTEL, IIT MADRAS & IIT TIRUPATI jointly organized One-day workshop on “NPTEL (National Programme on Technology Enhanced Learning)”',
            img: ["https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/1.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/2.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/3.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/4.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/5.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/6.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/7.jpg",
                "https://files.iittp.ac.in/images/demo/iit/Events/NPTEL/8.jpg"],
            dt: '30',
            my: 'Jun 2016',
            category: '2016'
        }
    ];

    const [activeButton, setActiveButton] = useState("View All");
    const [current, setcurrent] = useState(Data);

    const Filter = (category) => {
        setActiveButton(category);
        const arr = [];
        if (category === "View All") {
            setcurrent(Data);
        } else {
            Data.map((item) => {
                if (item.category === category) {
                    arr.push(item);
                }
            });
            setcurrent(arr);
        }
    };

    function chunkArray(array, chunkSize) {
        const chunkedArray = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            chunkedArray.push(array.slice(i, i + chunkSize));
        }
        return chunkedArray;
    }

    const [expandedDescriptions, setExpandedDescriptions] = useState({});

    // Function to toggle the description expansion
    const toggleDescriptionExpansion = (index) => {
        setExpandedDescriptions({
            ...expandedDescriptions, [index]: !expandedDescriptions[index],
        });
    };

    return (<div className="workshops">
        <Header/>
        <Breadcrumb subtitle={"Workshops"} title={"Home"}/>

        <section className="project-detail">
            <div className="container">
                <div className="section-title center-align mb-50 wow fadeInDown animated"
                     data-animation="fadeInDown" data-delay=".4s">
                    <h5><i className="fal fa-calendar"/> Events</h5>
                    <h2>Workshops</h2>
                </div>
                <Row>
                    <Col md={4} className="c-left">
                        <LeftEvents activeIndex={3}/>
                    </Col>

                    <Col md={8} className="c-left">
                        <div className="row align-items-end">
                            <div className="col-lg-12">
                                <div className="my-masonry text-center mb-50 wow fadeInRight animated"
                                     data-animation="fadeInRight" data-delay=".4s">
                                    <div className="button-group filter-button-group ">
                                        <button className={`${activeButton === "View All" ? "active" : ""}`}
                                                data-filter="*" onClick={() => Filter("View All")}> View All
                                        </button>
                                        <button className={`${activeButton === "2022" ? "active" : ""}`}
                                                data-filter=".2022" onClick={() => Filter("2022")}>2022
                                        </button>
                                        <button className={`${activeButton === "2020" ? "active" : ""}`}
                                                data-filter=".2020" onClick={() => Filter("2020")}>2020
                                        </button>
                                        <button className={`${activeButton === "2019" ? "active" : ""}`}
                                                data-filter=".2019" onClick={() => Filter("2019")}>2019
                                        </button>
                                        <button className={`${activeButton === "2018" ? "active" : ""}`}
                                                data-filter=".2018" onClick={() => Filter("2018")}>2018
                                        </button>
                                        <button className={`${activeButton === "2017" ? "active" : ""}`}
                                                data-filter=".2017" onClick={() => Filter("2017")}>2017
                                        </button>
                                        <button className={`${activeButton === "2016" ? "active" : ""}`}
                                                data-filter=".2016" onClick={() => Filter("2016")}>2016
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {chunkArray(current, 2).map((row, rowIndex) => (<Row key={rowIndex}>
                            {row.map((event, index) => (
                                <Col key={index} lg={6} md={6} sm={12} className="wow fadeInUp animated"
                                     data-animation="fadeInUp" data-delay=".4s">
                                    <div className="event-item mb-30 hover-zoomin">
                                        <div className="thumb">
                                            <Carousel showArrows={true} showThumbs={false} dynamicHeight={false}
                                                      selectedItem={0}>
                                                {event.img.map((image, imgIndex) => (<div key={imgIndex}>
                                                    <img src={image} alt={`event-img-${imgIndex}`}/>
                                                </div>))}
                                            </Carousel>
                                        </div>
                                        <div className="event-content">
                                            <div className="date">
                                                <strong>{event.dt}</strong> {event.my}
                                            </div>
                                            <h3 style={{minHeight: "87px"}}>
                                                <Link to="/single-event"> {event.title}</Link>
                                            </h3>
                                            <p>
                                                {expandedDescriptions[index] ? event.description : event.description.split(' ').slice(0, 20).join(' ')}
                                                {event.description.split(' ').length > 20 && (
                                                    <span className="read-more">
                                                        <button style={{
                                                            textDecoration: "underline",
                                                            color: "#007bff",
                                                            cursor: 'pointer',
                                                            padding: '0',
                                                            border: 'none',
                                                            background: 'none'
                                                        }}
                                                                onClick={() => toggleDescriptionExpansion(index)}>
                                                            {expandedDescriptions[index] ? " Show Less" : "...Show More"}
                                                        </button>
                                                    </span>)}
                                            </p>
                                            <div className="time">
                                                {event.duration} <i className="fal fa-long-arrow-right"/>{" "}
                                                <strong>{event.venue}</strong>
                                            </div>

                                   
                                        </div>
                                    </div>
                                </Col>))}
                        </Row>))}
                    </Col>
                </Row>
            </div>
        </section>
    </div>);
}
